import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksCounterpartyCreationPopup', {
    acctNum: 'Account no.',
    acctNumPlaceholder: "Enter account's name or number",
    addressHeader: 'Address',
    billingAddressHeader: 'Billing address',
    shippingAddressHeader: 'Shipping address',
    companyName: 'Company',
    companyNamePlaceholder: 'Enter company name',
    contactInformationHeader: '{counterparty} Information',
    currency: 'Currency',
    currencyPlaceholder: 'Currency',
    displayNameAs: 'Display name as',
    displayNameAsPlaceholder: 'Enter display name',
    displayNameLengthErrorText: 'Display name cannot exceed {length} characters.',
    doneButtonText: 'Create',
    doneButtonTitle: 'Create {counterparty}',
    doneCustomerButtonTitle: 'Create customer',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    familyName: 'Last name',
    familyNamePlaceholder: 'Enter last name',
    fax: 'Fax',
    faxPlaceholder: 'Enter fax',
    givenName: 'First name',
    givenNamePlaceholder: 'Enter first name',
    invalidDisplayNameErrorText: '{counterparty} name cannot contain the following symbols: ":", "<", ">", "&#"',
    middleName: 'Middle name',
    middleNamePlaceholder: 'Enter middle name',
    mobilePhone: 'Mobile',
    mobilePhonePlaceholder: 'Enter mobile phone',
    noEmojiInContactName: 'Emojis are not allowed in Display name',
    popupTitle: 'New {counterparty}',
    primaryPhone: 'Phone',
    primaryPhonePlaceholder: 'Enter phone',
    sameAsBillingAddress: 'Same as billing address',
    suffix: 'Suffix',
    suffixPlaceholder: 'Jr',
    title: 'Title',
    titlePlaceholder: 'Mr.',
    validationErrorText: 'Please fill in mandatory fields',
    website: 'Website',
    websitePlaceholder: 'Enter website URL in format https://www.intuit.com',
    vendor: 'Vendor',
    customer: 'Customer',
});
